import { render, staticRenderFns } from "./AcademicAllCoursesUniversityTemplate.html?vue&type=template&id=74f4d179&scoped=true&external"
import script from "./AcademicAllCoursesUniversityTemplate.vue?vue&type=script&lang=js"
export * from "./AcademicAllCoursesUniversityTemplate.vue?vue&type=script&lang=js"
import style0 from "./AcademicAllCoursesUniversityTemplate.scss?vue&type=style&index=0&id=74f4d179&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f4d179",
  null
  
)

export default component.exports